import axiosInstance from "@/services/axiosInterceptor";

export async function getChatMembers(groupId) {
  try {
    const response = await axiosInstance.get(`misc/group-chats/${groupId}/members`, {
      byPassLoader: true,
    });
    const data = response?.data;
    return data;
  } catch (error) {
    throw error;
  }
}
